// reach_ui/src/components/VastGPT/ResponseMenu.js
import React, { useState } from 'react'
import IconButton from '@material-ui/core/IconButton'
import Menu from '@material-ui/core/Menu'
import MoreVert from '@material-ui/icons/MoreVert'
// import GenerateEmailButton from './GenerateEmailButton'
// import GenerateTextButton from './GenerateTextButton'
import GenerateKnowledgeButton from './GenerateKnowledgeButton'

const ResponseMenu = ({ content, index }) => {
  const [anchorEl, setAnchorEl] = useState(null)

  function handleClick(event) {
    setAnchorEl(event.currentTarget)
  }

  function handleClose() {
    setAnchorEl(null)
  }

  return (
    <div style={{ position: 'absolute', left: 0, bottom: 0 }}>
      <IconButton
        aria-owns={anchorEl ? `ai-response-simple-menu-${index}` : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVert />
      </IconButton>
      <Menu
        id={`ai-response-simple-menu-${index}`}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <GenerateKnowledgeButton index={index} handleClose={handleClose}/>
        {/* <GenerateEmailButton handleClose={handleClose} content={content} />
        <GenerateTextButton handleClose={handleClose} content={content} /> */}
      </Menu>
    </div>
  )
}

export default ResponseMenu
